import React from 'react';
import PropTypes from 'prop-types';
import { CentralContainer as Wrapper } from './CentralContainer.styled';

export const OuterContainer = ({ children }) => (
    <Wrapper>
        {children}
    </Wrapper>
);

OuterContainer.propTypes = {
    children: PropTypes.any
};
